import SelectClub from './SelectClub';
export default SelectClub;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/SelectClub/components/SelectClub/index.ts